/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PoliciesIndexRouteImport } from './routes/policies/index'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index'
import { Route as IdentitiesIndexRouteImport } from './routes/identities/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.index'
import { Route as AgentIndexRouteImport } from './routes/agent.index'
import { Route as PoliciesSplatRouteImport } from './routes/policies/$'
import { Route as IntegrationsNewRouteImport } from './routes/integrations/new'
import { Route as IntegrationsEditRouteImport } from './routes/integrations/edit'
import { Route as IntegrationsAddIntegrationRouteImport } from './routes/integrations/add-integration'
import { Route as IdentitiesSplatRouteImport } from './routes/identities/$'
import { Route as DashboardSplatRouteImport } from './routes/dashboard.$'
import { Route as AgentSplatRouteImport } from './routes/agent.$'
import { Route as AdminSavRoleManagementIndexRouteImport } from './routes/admin/sav-role-management/index'
import { Route as AdminOverviewIndexRouteImport } from './routes/admin/overview/index'
import { Route as AdminMfaIndexRouteImport } from './routes/admin/mfa/index'
import { Route as AdminIspmUsersIndexRouteImport } from './routes/admin/ispm-users/index'
import { Route as IntegrationsUniversalOnboardingSplatRouteImport } from './routes/integrations/universalOnboarding.$'
import { Route as AdminSettingsSsoSettingsIndexRouteImport } from './routes/admin/settings/sso-settings/index'
import { Route as AdminSettingsSsoSettingsEditRouteImport } from './routes/admin/settings/sso-settings/edit'
import { Route as AdminSettingsSsoSettingsCreateRouteImport } from './routes/admin/settings/sso-settings/create'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesIndexRoute = PoliciesIndexRouteImport.update({
  id: '/policies/',
  path: '/policies/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/integrations/',
  path: '/integrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const IdentitiesIndexRoute = IdentitiesIndexRouteImport.update({
  id: '/identities/',
  path: '/identities/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentIndexRoute = AgentIndexRouteImport.update({
  id: '/agent/',
  path: '/agent/',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesSplatRoute = PoliciesSplatRouteImport.update({
  id: '/policies/$',
  path: '/policies/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsNewRoute = IntegrationsNewRouteImport.update({
  id: '/integrations/new',
  path: '/integrations/new',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsEditRoute = IntegrationsEditRouteImport.update({
  id: '/integrations/edit',
  path: '/integrations/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsAddIntegrationRoute =
  IntegrationsAddIntegrationRouteImport.update({
    id: '/integrations/add-integration',
    path: '/integrations/add-integration',
    getParentRoute: () => rootRouteImport,
  } as any)
const IdentitiesSplatRoute = IdentitiesSplatRouteImport.update({
  id: '/identities/$',
  path: '/identities/$',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSplatRoute = DashboardSplatRouteImport.update({
  id: '/dashboard/$',
  path: '/dashboard/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentSplatRoute = AgentSplatRouteImport.update({
  id: '/agent/$',
  path: '/agent/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSavRoleManagementIndexRoute =
  AdminSavRoleManagementIndexRouteImport.update({
    id: '/admin/sav-role-management/',
    path: '/admin/sav-role-management/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminOverviewIndexRoute = AdminOverviewIndexRouteImport.update({
  id: '/admin/overview/',
  path: '/admin/overview/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMfaIndexRoute = AdminMfaIndexRouteImport.update({
  id: '/admin/mfa/',
  path: '/admin/mfa/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIspmUsersIndexRoute = AdminIspmUsersIndexRouteImport.update({
  id: '/admin/ispm-users/',
  path: '/admin/ispm-users/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsUniversalOnboardingSplatRoute =
  IntegrationsUniversalOnboardingSplatRouteImport.update({
    id: '/integrations/universalOnboarding/$',
    path: '/integrations/universalOnboarding/$',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminSettingsSsoSettingsIndexRoute =
  AdminSettingsSsoSettingsIndexRouteImport.update({
    id: '/admin/settings/sso-settings/',
    path: '/admin/settings/sso-settings/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminSettingsSsoSettingsEditRoute =
  AdminSettingsSsoSettingsEditRouteImport.update({
    id: '/admin/settings/sso-settings/edit',
    path: '/admin/settings/sso-settings/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminSettingsSsoSettingsCreateRoute =
  AdminSettingsSsoSettingsCreateRouteImport.update({
    id: '/admin/settings/sso-settings/create',
    path: '/admin/settings/sso-settings/create',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/agent/$': typeof AgentSplatRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/identities/$': typeof IdentitiesSplatRoute
  '/integrations/add-integration': typeof IntegrationsAddIntegrationRoute
  '/integrations/edit': typeof IntegrationsEditRoute
  '/integrations/new': typeof IntegrationsNewRoute
  '/policies/$': typeof PoliciesSplatRoute
  '/agent/': typeof AgentIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/identities/': typeof IdentitiesIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/policies/': typeof PoliciesIndexRoute
  '/integrations/universalOnboarding/$': typeof IntegrationsUniversalOnboardingSplatRoute
  '/admin/ispm-users/': typeof AdminIspmUsersIndexRoute
  '/admin/mfa/': typeof AdminMfaIndexRoute
  '/admin/overview/': typeof AdminOverviewIndexRoute
  '/admin/sav-role-management/': typeof AdminSavRoleManagementIndexRoute
  '/admin/settings/sso-settings/create': typeof AdminSettingsSsoSettingsCreateRoute
  '/admin/settings/sso-settings/edit': typeof AdminSettingsSsoSettingsEditRoute
  '/admin/settings/sso-settings/': typeof AdminSettingsSsoSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/agent/$': typeof AgentSplatRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/identities/$': typeof IdentitiesSplatRoute
  '/integrations/add-integration': typeof IntegrationsAddIntegrationRoute
  '/integrations/edit': typeof IntegrationsEditRoute
  '/integrations/new': typeof IntegrationsNewRoute
  '/policies/$': typeof PoliciesSplatRoute
  '/agent': typeof AgentIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/identities': typeof IdentitiesIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/policies': typeof PoliciesIndexRoute
  '/integrations/universalOnboarding/$': typeof IntegrationsUniversalOnboardingSplatRoute
  '/admin/ispm-users': typeof AdminIspmUsersIndexRoute
  '/admin/mfa': typeof AdminMfaIndexRoute
  '/admin/overview': typeof AdminOverviewIndexRoute
  '/admin/sav-role-management': typeof AdminSavRoleManagementIndexRoute
  '/admin/settings/sso-settings/create': typeof AdminSettingsSsoSettingsCreateRoute
  '/admin/settings/sso-settings/edit': typeof AdminSettingsSsoSettingsEditRoute
  '/admin/settings/sso-settings': typeof AdminSettingsSsoSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/agent/$': typeof AgentSplatRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/identities/$': typeof IdentitiesSplatRoute
  '/integrations/add-integration': typeof IntegrationsAddIntegrationRoute
  '/integrations/edit': typeof IntegrationsEditRoute
  '/integrations/new': typeof IntegrationsNewRoute
  '/policies/$': typeof PoliciesSplatRoute
  '/agent/': typeof AgentIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/identities/': typeof IdentitiesIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/policies/': typeof PoliciesIndexRoute
  '/integrations/universalOnboarding/$': typeof IntegrationsUniversalOnboardingSplatRoute
  '/admin/ispm-users/': typeof AdminIspmUsersIndexRoute
  '/admin/mfa/': typeof AdminMfaIndexRoute
  '/admin/overview/': typeof AdminOverviewIndexRoute
  '/admin/sav-role-management/': typeof AdminSavRoleManagementIndexRoute
  '/admin/settings/sso-settings/create': typeof AdminSettingsSsoSettingsCreateRoute
  '/admin/settings/sso-settings/edit': typeof AdminSettingsSsoSettingsEditRoute
  '/admin/settings/sso-settings/': typeof AdminSettingsSsoSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/agent/$'
    | '/dashboard/$'
    | '/identities/$'
    | '/integrations/add-integration'
    | '/integrations/edit'
    | '/integrations/new'
    | '/policies/$'
    | '/agent/'
    | '/dashboard/'
    | '/identities/'
    | '/integrations/'
    | '/policies/'
    | '/integrations/universalOnboarding/$'
    | '/admin/ispm-users/'
    | '/admin/mfa/'
    | '/admin/overview/'
    | '/admin/sav-role-management/'
    | '/admin/settings/sso-settings/create'
    | '/admin/settings/sso-settings/edit'
    | '/admin/settings/sso-settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/agent/$'
    | '/dashboard/$'
    | '/identities/$'
    | '/integrations/add-integration'
    | '/integrations/edit'
    | '/integrations/new'
    | '/policies/$'
    | '/agent'
    | '/dashboard'
    | '/identities'
    | '/integrations'
    | '/policies'
    | '/integrations/universalOnboarding/$'
    | '/admin/ispm-users'
    | '/admin/mfa'
    | '/admin/overview'
    | '/admin/sav-role-management'
    | '/admin/settings/sso-settings/create'
    | '/admin/settings/sso-settings/edit'
    | '/admin/settings/sso-settings'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/agent/$'
    | '/dashboard/$'
    | '/identities/$'
    | '/integrations/add-integration'
    | '/integrations/edit'
    | '/integrations/new'
    | '/policies/$'
    | '/agent/'
    | '/dashboard/'
    | '/identities/'
    | '/integrations/'
    | '/policies/'
    | '/integrations/universalOnboarding/$'
    | '/admin/ispm-users/'
    | '/admin/mfa/'
    | '/admin/overview/'
    | '/admin/sav-role-management/'
    | '/admin/settings/sso-settings/create'
    | '/admin/settings/sso-settings/edit'
    | '/admin/settings/sso-settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  AgentSplatRoute: typeof AgentSplatRoute
  DashboardSplatRoute: typeof DashboardSplatRoute
  IdentitiesSplatRoute: typeof IdentitiesSplatRoute
  IntegrationsAddIntegrationRoute: typeof IntegrationsAddIntegrationRoute
  IntegrationsEditRoute: typeof IntegrationsEditRoute
  IntegrationsNewRoute: typeof IntegrationsNewRoute
  PoliciesSplatRoute: typeof PoliciesSplatRoute
  AgentIndexRoute: typeof AgentIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  IdentitiesIndexRoute: typeof IdentitiesIndexRoute
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute
  PoliciesIndexRoute: typeof PoliciesIndexRoute
  IntegrationsUniversalOnboardingSplatRoute: typeof IntegrationsUniversalOnboardingSplatRoute
  AdminIspmUsersIndexRoute: typeof AdminIspmUsersIndexRoute
  AdminMfaIndexRoute: typeof AdminMfaIndexRoute
  AdminOverviewIndexRoute: typeof AdminOverviewIndexRoute
  AdminSavRoleManagementIndexRoute: typeof AdminSavRoleManagementIndexRoute
  AdminSettingsSsoSettingsCreateRoute: typeof AdminSettingsSsoSettingsCreateRoute
  AdminSettingsSsoSettingsEditRoute: typeof AdminSettingsSsoSettingsEditRoute
  AdminSettingsSsoSettingsIndexRoute: typeof AdminSettingsSsoSettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies/': {
      id: '/policies/'
      path: '/policies'
      fullPath: '/policies/'
      preLoaderRoute: typeof PoliciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/': {
      id: '/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof IntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identities/': {
      id: '/identities/'
      path: '/identities'
      fullPath: '/identities/'
      preLoaderRoute: typeof IdentitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/': {
      id: '/agent/'
      path: '/agent'
      fullPath: '/agent/'
      preLoaderRoute: typeof AgentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies/$': {
      id: '/policies/$'
      path: '/policies/$'
      fullPath: '/policies/$'
      preLoaderRoute: typeof PoliciesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/new': {
      id: '/integrations/new'
      path: '/integrations/new'
      fullPath: '/integrations/new'
      preLoaderRoute: typeof IntegrationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/edit': {
      id: '/integrations/edit'
      path: '/integrations/edit'
      fullPath: '/integrations/edit'
      preLoaderRoute: typeof IntegrationsEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/add-integration': {
      id: '/integrations/add-integration'
      path: '/integrations/add-integration'
      fullPath: '/integrations/add-integration'
      preLoaderRoute: typeof IntegrationsAddIntegrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identities/$': {
      id: '/identities/$'
      path: '/identities/$'
      fullPath: '/identities/$'
      preLoaderRoute: typeof IdentitiesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/$': {
      id: '/dashboard/$'
      path: '/dashboard/$'
      fullPath: '/dashboard/$'
      preLoaderRoute: typeof DashboardSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/$': {
      id: '/agent/$'
      path: '/agent/$'
      fullPath: '/agent/$'
      preLoaderRoute: typeof AgentSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sav-role-management/': {
      id: '/admin/sav-role-management/'
      path: '/admin/sav-role-management'
      fullPath: '/admin/sav-role-management/'
      preLoaderRoute: typeof AdminSavRoleManagementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/overview/': {
      id: '/admin/overview/'
      path: '/admin/overview'
      fullPath: '/admin/overview/'
      preLoaderRoute: typeof AdminOverviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/mfa/': {
      id: '/admin/mfa/'
      path: '/admin/mfa'
      fullPath: '/admin/mfa/'
      preLoaderRoute: typeof AdminMfaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ispm-users/': {
      id: '/admin/ispm-users/'
      path: '/admin/ispm-users'
      fullPath: '/admin/ispm-users/'
      preLoaderRoute: typeof AdminIspmUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/universalOnboarding/$': {
      id: '/integrations/universalOnboarding/$'
      path: '/integrations/universalOnboarding/$'
      fullPath: '/integrations/universalOnboarding/$'
      preLoaderRoute: typeof IntegrationsUniversalOnboardingSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings/sso-settings/': {
      id: '/admin/settings/sso-settings/'
      path: '/admin/settings/sso-settings'
      fullPath: '/admin/settings/sso-settings/'
      preLoaderRoute: typeof AdminSettingsSsoSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings/sso-settings/edit': {
      id: '/admin/settings/sso-settings/edit'
      path: '/admin/settings/sso-settings/edit'
      fullPath: '/admin/settings/sso-settings/edit'
      preLoaderRoute: typeof AdminSettingsSsoSettingsEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings/sso-settings/create': {
      id: '/admin/settings/sso-settings/create'
      path: '/admin/settings/sso-settings/create'
      fullPath: '/admin/settings/sso-settings/create'
      preLoaderRoute: typeof AdminSettingsSsoSettingsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  AgentSplatRoute: AgentSplatRoute,
  DashboardSplatRoute: DashboardSplatRoute,
  IdentitiesSplatRoute: IdentitiesSplatRoute,
  IntegrationsAddIntegrationRoute: IntegrationsAddIntegrationRoute,
  IntegrationsEditRoute: IntegrationsEditRoute,
  IntegrationsNewRoute: IntegrationsNewRoute,
  PoliciesSplatRoute: PoliciesSplatRoute,
  AgentIndexRoute: AgentIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  IdentitiesIndexRoute: IdentitiesIndexRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
  PoliciesIndexRoute: PoliciesIndexRoute,
  IntegrationsUniversalOnboardingSplatRoute:
    IntegrationsUniversalOnboardingSplatRoute,
  AdminIspmUsersIndexRoute: AdminIspmUsersIndexRoute,
  AdminMfaIndexRoute: AdminMfaIndexRoute,
  AdminOverviewIndexRoute: AdminOverviewIndexRoute,
  AdminSavRoleManagementIndexRoute: AdminSavRoleManagementIndexRoute,
  AdminSettingsSsoSettingsCreateRoute: AdminSettingsSsoSettingsCreateRoute,
  AdminSettingsSsoSettingsEditRoute: AdminSettingsSsoSettingsEditRoute,
  AdminSettingsSsoSettingsIndexRoute: AdminSettingsSsoSettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
